import React, { createContext, useContext, useState } from "react";

const NotificationCountContext = createContext();

export const useNotificationCount = () => useContext(NotificationCountContext);

export const NotificationCountProvider = ({ children }) => {
    const [count, setCount] = useState(0);

    const increment = () => setCount((prev) => prev + 1);
    const decrement = () => setCount((prev) => (prev > 0 ? prev - 1 : 0));
    const reset = () => setCount(0);
    const setNotificationCount = (value) => setCount(value);

    return (
        <NotificationCountContext.Provider
            value={{ count, increment, decrement, reset, setNotificationCount }}
        >
            {children}
        </NotificationCountContext.Provider>
    );
};
